export const resultCodes = {
  AUTHORISED: 'Authorised',
  PENDING: 'Pending',
  RECEIVED: 'Received',
  REFUSED: 'Refused'
}
